/**
 * 我采购的比价列表
 */
export const PRICE_COMPARE_PURCHASE_LIST_PAGE_PATH =
  '/priceCompare/list/purchase'
